import { render } from "./CourseListType.vue?vue&type=template&id=446a74c8&scoped=true"
import script from "./CourseListType.vue?vue&type=script&lang=js"
export * from "./CourseListType.vue?vue&type=script&lang=js"

import "./CourseListType.vue?vue&type=style&index=0&id=446a74c8&lang=scss&scoped=true"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446a74c8"]])

export default __exports__